export default "__VITE_ASSET__BEKvoVKu__"